import React, { useEffect, useState, useCallback } from 'react';
import TextFieldCS from '../../../common/ComponentesCS/TextFieldCS';
import { Button } from '@material-ui/core';
// import APP from '../../common/tools/AppRoutes';

const Filters = ({ onFiltersChange, onClearFilters }) => {
    // Estado para manejar múltiples campos de texto específicos de proyectos
    const [filters, setFilters] = useState({
        idProyecto: '',
        nombreProyecto: '',
        cliente: '',
        tipoProyecto: '',
        estatusProyecto: ''
    });

    // Efecto para notificar cambios de filtros automáticamente
    useEffect(() => {
        // Solo notificar si hay algún filtro activo para evitar llamadas innecesarias
        const hasActiveFilters = Object.values(filters).some(value => value.trim() !== '');

        if (hasActiveFilters && onFiltersChange) {
            onFiltersChange(filters);
        } else if (!hasActiveFilters && onClearFilters) {
            // Si no hay filtros activos, limpiar
            onClearFilters();
        }
    }, [filters]); // Solo 'filters' en las dependencias

    // Función para manejar cambios en cualquier TextField
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));
    };

    // Función para limpiar todos los filtros
    const clearFilters = useCallback(() => {
        const emptyFilters = {
            idProyecto: '',
            nombreProyecto: '',
            cliente: '',
            tipoProyecto: '',
            estatusProyecto: ''
        };
        setFilters(emptyFilters);

        // Notificar al componente padre
        if (onClearFilters) {
            onClearFilters();
        }
    }, [onClearFilters]);

    return (
        <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', gap: '15px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap', width: '80%' }}>
                <TextFieldCS
                    id="idProyecto"
                    name="idProyecto"
                    label="ID Proyecto"
                    value={filters.idProyecto}
                    onChange={handleInputChange}
                    style={{ minWidth: '200px' }}
                />

                <TextFieldCS
                    id="nombreProyecto"
                    name="nombreProyecto"
                    label="Nombre Proyecto"
                    value={filters.nombreProyecto}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                />

                {/* <TextFieldCS
                    id="cliente"
                    name="cliente"
                    label="Cliente"
                    value={filters.cliente}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                /> */}
                {/* </div>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap' }}> */}
                <TextFieldCS
                    id="tipoProyecto"
                    name="tipoProyecto"
                    label="Tipo Proyecto"
                    value={filters.tipoProyecto}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                />

                <TextFieldCS
                    id="estatusProyecto"
                    name="estatusProyecto"
                    label="Estatus Proyecto"
                    value={filters.estatusProyecto}
                    onChange={handleInputChange}

                    style={{ minWidth: '200px' }}
                />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', width: '20%' }}>
                {/* <button
                    onClick={clearFilters}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#f44336',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        height: '40px'
                    }}
                >
                    Limpiar Filtros
                </button> */}
                <Button className="botonAmarillo floatLeft" onClick={clearFilters} variant="contained">Limpiar Filtros</Button>

            </div>
        </div>
    );
};

export default Filters;
